var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramProfile = function SvgInstagramProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#InstagramProfile_svg__a)",
    d: "M18.244 3.5H9.756A6.263 6.263 0 0 0 3.5 9.756v8.488A6.263 6.263 0 0 0 9.756 24.5h8.488a6.263 6.263 0 0 0 6.256-6.256V9.756A6.263 6.263 0 0 0 18.244 3.5zm4.143 14.744a4.143 4.143 0 0 1-4.143 4.143H9.756a4.143 4.143 0 0 1-4.143-4.143V9.756a4.143 4.143 0 0 1 4.143-4.143h8.488a4.143 4.143 0 0 1 4.143 4.143v8.488z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#InstagramProfile_svg__b)",
    d: "M14 8.569a5.437 5.437 0 0 0-5.432 5.43A5.438 5.438 0 0 0 14 19.431c2.995 0 5.431-2.436 5.431-5.431S16.995 8.569 14 8.569zm0 8.75a3.32 3.32 0 1 1 .003-6.639 3.32 3.32 0 0 1-.004 6.639z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#InstagramProfile_svg__c)",
    d: "M19.442 9.91a1.301 1.301 0 1 0 .002-2.604 1.301 1.301 0 0 0-.002 2.605z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "InstagramProfile_svg__a",
    x1: 14,
    x2: 14,
    y1: 24.439,
    y2: 3.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "InstagramProfile_svg__b",
    x1: 14,
    x2: 14,
    y1: 24.439,
    y2: 3.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "InstagramProfile_svg__c",
    x1: 19.442,
    x2: 19.442,
    y1: 24.439,
    y2: 3.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
};
export default SvgInstagramProfile;